var editorBlocker = window.top.location.pathname.indexOf('/admin/themes/');

if( editorBlocker == -1 ){
	function redirectModal(){
		if(window.location.search.indexOf('-default') <= -1){
			// Make sure other popups don't fire while the redirect is on
			theme.redirectModal = true;
			$('.redirect-lock').show();
		} else {
			// Tell all the other popups it's ok to fire now
			theme.redirectModal = false;
		}
	}

	function checkRedirectCookie(type){
		
			if( !Cookies.get('multistore') || Cookies.get('multistore') != '' ){
				!Cookies.get('multistore') ? console.log('No Redirect Cookie Detected - Popup Active') : console.log('Redirect Cookie Detected = '+Cookies.get('multistore'));
				ipService();
			}
		
	}

	function setRedirectCookie(cookieName, type) {
		if( Cookies.get('multistore') ){
			var delete_cookie = function(name) {
			    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
			};
			delete_cookie('multistore');
		}
		setTimeout(function(){ Cookies.set('multistore', cookieName, { expires: 365, path: '/' }); }, 150);
	}

	if(window.location.search.indexOf('?redirect=') > -1){
		var redirectValue = window.location.search.replace('?redirect=','');
		setRedirectCookie(redirectValue);
	} else {
		checkRedirectCookie();
	}
	
		$(document).ready(function(){
			$('.redirect-picker').on('change', function(){
				var url           = $(this).val(),
				selectedStore = $(".redirect-picker option:selected").data('store');
				setRedirectCookie(selectedStore, 'referrer');
				setTimeout(function(){ window.location.href = url+'?redirect='+selectedStore }, 300);
			});
		});
	

	function ipService(){
		var timing = 500;

		
	}
};